var React = require('react');

function Steam (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M49.93,4A46.53,46.53,0,0,0,3.53,47L28,57.29a13.5,13.5,0,0,1,7.78-2.46c.31,0,.61,0,.91,0l11-16.16h0A17.75,17.75,0,1,1,65.41,56.45H65L49.26,67.64h0c0,.25,0,.5,0,.75A13.55,13.55,0,0,1,22.4,70.81L5.29,63.76A46.55,46.55,0,1,0,49.93,4Z","key":0}),React.createElement("path",{"d":"M35.73,78.37a10,10,0,1,0-3.57-19.31C36.72,61,42.81,62,42.81,68.23a7.39,7.39,0,0,1-7.39,7.39c-2.35,0-6.44-2.1-8.75-3.05A10,10,0,0,0,35.73,78.37Z","key":1}),React.createElement("path",{"d":"M65.46,50.39A11.75,11.75,0,1,0,53.72,38.64,11.75,11.75,0,0,0,65.46,50.39Zm0-20.72a9,9,0,1,1-9,9A9,9,0,0,1,65.46,29.67Z","key":2})]);
}

Steam.defaultProps = {"id":"steam","data-name":"steam","viewBox":"0 0 100 100"};

module.exports = Steam;

Steam.default = Steam;
